import { AfterViewInit, Component,  HostListener,  OnInit} from '@angular/core';
declare var bootstrap: any;

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  })
export class TermsAndConditionsComponent implements OnInit  {


  constructor(
  ) { }


  ngOnInit(): void {
    
  }

  isOpen = false;

  open() {
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
  }
  
    // Close modal when clicking outside content
  onBackdropClick(event: MouseEvent) {
    if ((<HTMLElement>event.target).classList.contains('custom-modal')) {
      this.close();
    }
  }

  // Close modal on Escape key
  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    if (this.isOpen) {
      this.close();
    }
  }
}
